import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { Order } from 'sections/LKSection/modules/OrderModule/stores/entity/Order'
import { getOrderPageKey } from 'sections/LKSection/modules/OrderModule/utils'
import { Margin } from 'components/ui'
import { Flex, Text } from 'components/uiKit'
import { Country } from 'shared/types/types'

import { OrderItemStatusHeader } from '../OrderItemStatusHeader/OrderItemStatusHeader'

type OrderStatusReadyToActivateProps = {
  order: Order
}

export const OrderStatusReadyToActivate = observer(({ order }: OrderStatusReadyToActivateProps) => {
  const { t } = useTranslation()

  const getKey = (key: string) => `${OrderKeys.orderItemPage}.${key}`

  return (
    <>
      {order.country === Country.RU && !order.exPickPointId ? (
        <>
          <OrderItemStatusHeader
            type="success"
            title={t(getKey('step'), { count: 2 })}
            subTitle={t(getKey('Оплачена'))}
          />
          <OrderItemStatusHeader
            type="success"
            title={t(getKey('step'), { count: 3 })}
            subTitle={t(getOrderPageKey('Одобрена'))}
          />
          <OrderItemStatusHeader
            type="success"
            title={t(getKey('step'), { count: 4 })}
            subTitle={t(getOrderPageKey('Отправлена на активацию'))}
            isActive
          />
        </>
      ) : (
        <>
          <OrderItemStatusHeader
            type="success"
            title={t(getKey('step'), { count: 2 })}
            subTitle={t(getOrderPageKey('Одобрена'))}
          />
          <OrderItemStatusHeader
            type="success"
            title={t(getKey('step'), { count: 3 })}
            subTitle={t(getOrderPageKey('Отправлена на активацию'))}
            isActive
          />
        </>
      )}

      <Margin mt={32}>
        <Flex vertical>
          <Text>{t(getKey('Дождитесь активации вашего ПВЗ'))}:</Text>
          <Text>{order.fullAddress}</Text>
        </Flex>
      </Margin>
    </>
  )
})
